export interface Draft {
  id: string;
  name: string;
  formats: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: Record<string, any>;
  status: 'draft';
  savedAt: string;
  template_id: string;
}

const KEY = (templateId: string): string => `shake:drafts:${templateId}`;

export function getDrafts(templateId: string): Draft[] {
  try {
    const raw = localStorage.getItem(KEY(templateId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function saveDraft(
  templateId: string,
  draft: Partial<Draft> & { name: string; formats: string[]; fields: Record<string, unknown> },
): Draft {
  const now = new Date().toISOString();
  const withMeta: Draft = {
    ...draft,
    id: draft.id || `${now}-${Math.random().toString(36).slice(2, 8)}`,
    status: 'draft',
    savedAt: now,
    template_id: templateId,
  };

  const current = getDrafts(templateId).filter((d) => d.id !== withMeta.id);
  localStorage.setItem(KEY(templateId), JSON.stringify([withMeta, ...current]));
  return withMeta;
}

export function removeDraft(templateId: string, draftId: string): boolean {
  const current = getDrafts(templateId).filter((d) => d.id !== draftId);
  localStorage.setItem(KEY(templateId), JSON.stringify(current));
  return true;
}
